import type { AnchorHTMLAttributes, ReactNode } from "react"
import { Link } from "react-router"

type AnimatedLinkProps = {
  to: string
  className?: string
  lineGapPixel?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10
  children?: ReactNode
} & AnchorHTMLAttributes<HTMLAnchorElement>

export const AnimatedLink = ({
  to,
  className,
  lineGapPixel = 8,
  children,
  /*
   * biome-ignore lint/complexity/noExcessiveCognitiveComplexity:
   *  -> lineGapPixelの多段条件分岐による警告を抑止
   */
}: AnimatedLinkProps) => (
  <Link
    to={to}
    className={`
      ${className ?? ""}
      relative
      leading-[1]
      text-nowrap

      md:after:content-['']
      md:after:absolute
      ${
        // biome-ignore format: フォーマットされると見辛いため
        lineGapPixel === 1 ? "md:after:bottom-[-1px]"
        : lineGapPixel === 2 ? "md:after:bottom-[-2px]"
        : lineGapPixel === 3 ? "md:after:bottom-[-3px]"
        : lineGapPixel === 4 ? "md:after:bottom-[-4px]"
        : lineGapPixel === 5 ? "md:after:bottom-[-5px]"
        : lineGapPixel === 6 ? "md:after:bottom-[-6px]"
        : lineGapPixel === 7 ? "md:after:bottom-[-7px]"
        : lineGapPixel === 8 ? "md:after:bottom-[-8px]"
        : lineGapPixel === 9 ? "md:after:bottom-[-9px]"
        : lineGapPixel === 10 ? "md:after:bottom-[-10px]"
        : ""
      }
      md:after:left-0
      md:after:w-0
      md:after:border-b-[1.5px]
      md:after:border-black
      md:after:opacity-0
      md:after:transition-all
      md:after:duration-500
      md:after:hover:w-full
      md:after:hover:opacity-100
   `}
  >
    {children}
  </Link>
)
